var keywords = [];
var macros = [];

const DJANGO_TEMPLATE_BLOCKS  =  [
    {displayText: 'block', text: ' block %}{{  }}{% endblock '}, 
    {displayText: 'endblock', text: 'endblock'},
    {displayText: 'for', text: ' for  in  %}{{  }}{% endfor '},
    {displayText: 'endfor', text: 'endfor'},
    {displayText: 'true', text: 'true'},
    {displayText: 'false', text: 'false'},
    {displayText: 'filter', text: ' filter %}{{  }}{% endfilter '},
    {displayText: 'endfilter', text: 'endfilter'},
    {displayText: 'if', text: ' if %}{{  }}{% endif '},
    {displayText: 'else', text: ' else '},
    {displayText: 'elif', text: ' elif  '},
    {displayText: 'endif', text: ' endif '},
    {displayText: 'ifchanged', text: ' ifchanged %}{{  }}{% endifchanged '},
    {displayText: 'translate', text: ' translate "" as '},
    {displayText: 'autoescape', text: ' autoescape %}{% endautoescape '},
    {displayText: 'comment', text: ' comment %}{{  }}{% endcomment '},
    {displayText: 'ifchanged', text: ' ifchanged %}{{  }}{% endifchanged '},
    {displayText: 'blocktrans', text: ' blocktrans %}{{  }}{% endblocktrans '},
    {displayText: 'endblocktrans', text: 'endblocktrans'},
    {displayText: 'regroup', text: ' regroup  as  '},
    {displayText: 'spaceless', text: ' spaceless %}{{  }}{% endspaceless '},
    {displayText: 'verbatim', text: ' verbatim %}{{  }}{% endverbatim '},
    {displayText: 'endverbatim', text: 'endverbatim'},
    {displayText: 'with', text: ' with  =  %}{{  }}{% endwith '},
    {displayText: 'resetcycle', text: 'resetcycle'},
    {displayText: 'templatetag', text: ' templatetag '},
];

const DJANGO_FILTERS  =  [
    {displayText: 'default', text: 'default:""'},
    {displayText: 'length', text: 'length'},
    {displayText: 'add', text: ' add: '},
    {displayText: 'addslashes', text: ' addslashes '},
    {displayText: 'capfirst', text: ' capfirst '},
    {displayText: 'center', text: 'center:""'},
    {displayText: 'cut', text: 'cut:""'},
    {displayText: 'date', text: 'date:""'},
    {displayText: 'default_if_none', text: 'default_if_none:""'},
    {displayText: 'dictsort', text: 'dictsort:""'},
    {displayText: 'dictsortreversed', text: 'dictsortreversed:""'},
    {displayText: 'divisibleby', text: 'divisibleby:""'},
    {displayText: 'escape', text: 'escape'},
    {displayText: 'escapejs', text: 'escapejs'},
    {displayText: 'escapeseq', text: 'escapeseq'},
    {displayText: 'filesizeformat', text: 'filesizeformat'},
    {displayText: 'first', text: 'first'},
    {displayText: 'floatformat', text: 'floatformat'},
    {displayText: 'force_escape', text: 'force_escape'},
    {displayText: 'get_digit', text: 'get_digit:""'},
    {displayText: 'iriencode', text: 'iriencode'},
    {displayText: 'join', text: 'join:""'},
    {displayText: 'last', text: 'last'},
    {displayText: 'length_is', text: 'length_is:""'},
    {displayText: 'linebreaks', text: 'linebreaks'},
    {displayText: 'linebreaksbr', text: 'linebreaksbr'},
    {displayText: 'linenumbers', text: 'linenumbers'},
    {displayText: 'ljust', text: 'ljust'},
    {displayText: 'lower', text: 'lower'},
    {displayText: 'make_list', text: 'make_list'},
    {displayText: 'phone2numeric', text: 'phone2numeric'},
    {displayText: 'pluralize', text: 'pluralize'},
    {displayText: 'pprint', text: 'pprint'},
    {displayText: 'random', text: 'random'},
    {displayText: 'rjust', text: 'rjust'},
    {displayText: 'safe', text: 'safe'},
    {displayText: 'safeseq', text: 'safeseq'},
    {displayText: 'slice', text: 'slice:""'},
    {displayText: 'slugify', text: 'slugify'},
    {displayText: 'stringformat', text: 'stringformat:""'},
    {displayText: 'time', text: 'time:""'},
    {displayText: 'timesince', text: 'timesince:'},
    {displayText: 'timeuntil', text: 'timeuntil:'},
    {displayText: 'title', text: 'title'},
    {displayText: 'truncatechars', text: 'truncatechars:'},
    {displayText: 'truncatechars_html', text: 'truncatechars_html:'},
    {displayText: 'truncatewords', text: 'truncatewords:'},
    {displayText: 'truncatewords_html', text: 'truncatewords_html:'},
    {displayText: 'unordered_list', text: 'unordered_list'},
    {displayText: 'upper', text: 'upper'},
    {displayText: 'urlencode', text: 'urlencode'},
    {displayText: 'urlize', text: 'urlize'},
    {displayText: 'urlizetrunc', text: 'urlizetrunc:'},
    {displayText: 'wordcount', text: 'wordcount'},
    {displayText: 'wordwrap', text: 'wordwrap:'},
    {displayText: 'yesno', text: 'yesno:""'},
    {displayText: 'static', text: 'static'},
];

const DJANGO_TAGS  =  [
    {displayText: 'on', text: 'on'},
    {displayText: 'off', text: 'off'},
    {displayText: 'extends', text: 'extends'},
    {displayText: 'debug', text: 'debug'},
    {displayText: 'cycle', text: 'cycle'},
    {displayText: 'empty', text: 'empty'},
    {displayText: 'not', text: 'not'},
    {displayText: 'or', text: 'or'},
    {displayText: 'as', text: 'as'},
    {displayText: 'and', text: 'and'},
    {displayText: 'in', text: 'in'},
    {displayText: 'true', text: 'true'},
    {displayText: 'false', text: 'false'},
    {displayText: 'none', text: 'none'},
    {displayText: 'with', text: 'with'},
    {displayText: 'load', text: ' load '},
    {displayText: 'lorem', text: 'lorem [count] [w|p|b] [random]'},
    {displayText: 'now', text: ' now "" '},
    {displayText: 'url', text: ' url \'\' '},
    {displayText: 'widthratio', text: ' widthratio  as  '},
    {displayText: 'import', text: ' import  '},
    {displayText: 'include', text: ' include  '},
    {displayText: 'force_escape', text: 'force_escape'},
    {displayText: 'first_of', text: 'first_of '},
];

export function getKeywords(findText, django_block_matched) {
    let uniqueList = [];
    let combinedList = [...(django_block_matched ? [...macros, ...DJANGO_TEMPLATE_BLOCKS] : []), ...keywords, ...DJANGO_FILTERS, ...DJANGO_TAGS];
    let searchedList = [...new Set(combinedList.filter(e => e.displayText.includes(findText)))];
    if (searchedList.length > 0) {
        searchedList.sort((a, b) => a.displayText.localeCompare(b.displayText));
        searchedList.forEach(element => {
            if (!uniqueList.find(obj => obj.displayText === element.displayText)) {
                uniqueList.push(element); 
            }
        });
    }
    return uniqueList;
}

export function setCuratedPlanetKeywords(tagDictionary) {
    tagDictionary.forEach(item => keywords.push(item));
}

export function setCuratedPlanetMacros(tagDictionaryMacros) {
    macros = tagDictionaryMacros;
}
